import type { ArabicLetter } from '../types';

export const arabicLetters: ArabicLetter[] = [
  { id: 'alif', letter: 'ا', transliteration: 'Alif', voiceText: 'أَلِف' },
  { id: 'ba', letter: 'ب', transliteration: 'Ba', voiceText: 'بَاء' },
  { id: 'ta', letter: 'ت', transliteration: 'Ta', voiceText: 'تَاء' },
  { id: 'tha', letter: 'ث', transliteration: 'Tha', voiceText: 'ثَاء' },
  { id: 'jeem', letter: 'ج', transliteration: 'Jeem', voiceText: 'جِيم' },
  { id: 'ha', letter: 'ح', transliteration: 'Ha', voiceText: 'حَاء' },
  { id: 'kha', letter: 'خ', transliteration: 'Kha', voiceText: 'خَاء' },
  { id: 'dal', letter: 'د', transliteration: 'Dal', voiceText: 'دَال' },
  { id: 'dhal', letter: 'ذ', transliteration: 'Dhal', voiceText: 'ذَال' },
  { id: 'ra', letter: 'ر', transliteration: 'Ra', voiceText: 'رَاء' },
  { id: 'zay', letter: 'ز', transliteration: 'Zay', voiceText: 'زَاي' },
  { id: 'seen', letter: 'س', transliteration: 'Seen', voiceText: 'سِين' },
  { id: 'sheen', letter: 'ش', transliteration: 'Sheen', voiceText: 'شِين' },
  { id: 'sad', letter: 'ص', transliteration: 'Sad', voiceText: 'صَاد' },
  { id: 'dad', letter: 'ض', transliteration: 'Dad', voiceText: 'ضَاد' },
  { id: 'taa', letter: 'ط', transliteration: 'Taa', voiceText: 'طَاء' },
  { id: 'zaa', letter: 'ظ', transliteration: 'Zaa', voiceText: 'ظَاء' },
  { id: 'ayn', letter: 'ع', transliteration: 'Ayn', voiceText: 'عَيْن' },
  { id: 'ghayn', letter: 'غ', transliteration: 'Ghayn', voiceText: 'غَيْن' },
  { id: 'fa', letter: 'ف', transliteration: 'Fa', voiceText: 'فَاء' },
  { id: 'qaf', letter: 'ق', transliteration: 'Qaf', voiceText: 'قَاف' },
  { id: 'kaf', letter: 'ك', transliteration: 'Kaf', voiceText: 'كَاف' },
  { id: 'lam', letter: 'ل', transliteration: 'Lam', voiceText: 'لَام' },
  { id: 'meem', letter: 'م', transliteration: 'Meem', voiceText: 'مِيم' },
  { id: 'noon', letter: 'ن', transliteration: 'Noon', voiceText: 'نُون' },
  { id: 'haa', letter: 'ه', transliteration: 'Haa', voiceText: 'هَاء' },
  { id: 'waw', letter: 'و', transliteration: 'Waw', voiceText: 'وَاو' },
  { id: 'ya', letter: 'ي', transliteration: 'Ya', voiceText: 'يَاء' },
];
